import { density } from '@hubble/tokens/web';

const getDensityContentSpacing = densityType => `inset: 0px -${density.contentItems.padding.right[densityType]} 0px -${density.contentItems.padding.left[densityType]};
`;
const getDensityPadding = densityType => `padding: ${density.contentItems.padding.top[densityType]} 0px ${density.contentItems.padding.bottom[densityType]} 0px;
`;

export { getDensityContentSpacing, getDensityPadding };
